module.exports = "/_next/static/images/SingleSourceOfTruth@2x-60127f16fb00f89ce443e1d9bcc742c0.webp";